import { useContext } from 'react';
import { MediaContext } from '../contexts/MediaContext';

// Custom hook to access the MediaContext.
export function useMedia() {
  const context = useContext(MediaContext);

  if (context === undefined) {
    throw new Error('useMedia must be used within an MediaProvider');
  }
  return context;
}
